import { SecurityInventoryCategory, SecurityInventoryItem } from '@x-guard/xgac-types/xgac';
import { Identifier, useRecordContext } from 'react-admin';
import { useMemo } from 'react';
import { Checkbox, IconButton, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import {
  InventoryCategoryIconName,
} from '../../../components/icons/inventoryCategoryIcons';
import { IconField } from '../../../components/fields/IconField';

const NameDisplay = (props: { name: string }) => {

  return (
    <Box sx={{
      fontWeight: 'bold',
      marginLeft: '15px',
    }}>
      {props.name}
    </Box>
  );

};
export const DataGridListItem = (props: {
  mouseHoverId: Identifier | null;
  categories: SecurityInventoryCategory[];
  setMouseHoverId: React.Dispatch<React.SetStateAction<Identifier | null>>;
  selectedIds: Identifier[];
  setSelectedIds: React.Dispatch<React.SetStateAction<Identifier[]>>;
  onFocus: (itemId: Identifier, item: SecurityInventoryItem) => void;
  setEditItemRecord: React.Dispatch<React.SetStateAction<SecurityInventoryItem | null>>;
  setEditItemModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {

  const record = useRecordContext<SecurityInventoryItem>();
  const iconName = useMemo(() => {

    return props.categories.find((c) => c._id === record?.category._id)?.icon as InventoryCategoryIconName;

  }, [props.categories, record?.category._id]);

  if (!record) return <></>;
  const id = record._id;

  const showIdleRow = props.mouseHoverId !== id && props.selectedIds.length === 0;

  return (
    <div
      id={`inventory-item-${id}`}
      onMouseEnter={() => props.setMouseHoverId(id)}
      onMouseLeave={() => props.setMouseHoverId(null)}
      onClick={() => props.onFocus(id, record)}
      style={{ cursor: 'pointer' }}
    >
      <div className={props.selectedIds.includes(id) ? 'button-sidebar-grid-row selected-row' : 'button-sidebar-grid-row'}>
        {showIdleRow ? (
          <>
            <div className="button-sidebar-grid-name">
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 15,
                height: 15,
                flexShrink: 0,
              }}>
                <IconField iconName={iconName} source={iconName} />
              </Box>
              <NameDisplay name={record.name} />
            </div>
          </>
        ) : (
          <>
            <div className="button-sidebar-grid-name">
              <Checkbox
                checked={props.selectedIds.includes(id)}
                size="small"
                className="button-sidebar-checkbox"
                onClick={(e) => {

                  e.stopPropagation();
                  if (props.selectedIds.includes(id)) {

                    props.setSelectedIds(props.selectedIds.filter((selectedId) => selectedId !== id));

                  } else {

                    props.setSelectedIds([...props.selectedIds, id]);

                  }

                }}
              />
              <NameDisplay name={record.name} />
            </div>
            {props.mouseHoverId === id ? (
              <IconButton
                size="small"
                sx={{ padding: 0, margin: 0 }}
                onClick={(e) => {

                  e.stopPropagation();
                  props.setEditItemRecord(record);
                  props.setEditItemModalOpen(true);

                }}
              >
                <EditIcon sx={{ padding: 0, margin: 0, fontSize: '20px' }} />
              </IconButton>
            ) : (
              <div
                style={{
                  minWidth: 32,
                  flexShrink: 0,
                  alignSelf: 'center',
                }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );

};
